import React, { useState, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";

import { useDocuments, documentTypes as cashSalesDocType, targetTypes } from "../../../hooks/api/useDocuments";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useAppContextFeatures } from "../../../context/AppContext";

import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import {
    getQrCodeDataUrl,
    outputTypes as scanDataOutputTypes,
    scopeTypes as scanDataScopeTypes,
    targetTypes as scanDataTargetTypes
} from "../../../hooks/useScanData";
import { useTranslations } from '../../../hooks/useTranslations';

import { CommonPdf, renderModes, documentTypes } from "../../common/CommonPdf";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import CommonRestricted from "../../common/CommonRestricted";

import DocumentViewFooter from "../ViewDocumentFooter";
import ViewDocumentDependency from "../ViewDocumentDependency";
import DocumentQrCode from "../DocumentQrCode";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledContent2 = styled(Typography)(({ theme }) => ({
    fontSize: '0.8rem',
    mt: 2
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

export default function ViewRetailCashSales({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { id } = useParams();

    const { setSystemLoading, openCustomDrawer } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { get: getDocument } = useDocuments({ documentType: cashSalesDocType.retailCashSales, targetType: cashSalesDocType.retailCashSales});
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.retailCashSales.id)

    const { formatCurrencyDisplay, currencyAbb } = useSystemUtils();

    const navigate = useNavigate();

    const [data, setData] = useState()

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            let response = await getDocument({ id, dataTypesArray: ["dependency", "adjustment"] });
            // console.log('response?.data?.items', response?.data)
            setData(response?.data)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        fetchData();

    }, [])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageView.id })) {
            props.push({
                displayText: "Print Preview",
                onClick: () => {

                    data.qrCodeData = getQrCodeDataUrl()

                    openCustomDrawer({
                        show: true,
                        anchor: "right",
                        title: `Preview PDF`,
                        PaperProps: {
                            sx: { width: 2 / 3 }
                        },
                        // handleOnClose: () => setPreviewPdfOpen(false),
                        ComponentActions:
                            <></>,
                        // <Button
                        //     variant='outlined'
                        //     color='inherit'
                        //     type='submit'
                        // >
                        //     Save Changes
                        // </Button>,
                        ComponentBody:
                            <CommonPdf
                                routeType={routeType}
                                renderMode={renderModes.preview.id}
                                documentType={documentTypes.retailCashSales.id}
                                document={{
                                    title: data?.document?.doc_number
                                }}
                                data={data}
                            />
                    })

                    return true;

                }
            })
        }

        return props
    }

    const RenderTable = () => {

        if (!data) return <></>

        return (
            <TableContainer
                // component={Paper}
                sx={{
                    minHeight: 400,
                    maxHeight: 400
                }}
            >
                <Table
                    size="small"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <TableCell width={20}>#</TableCell>
                            {/* <TableCell align="center" width={120}>Stock Posted</TableCell> */}
                            <TableCell width={200}>{t('code')}</TableCell>
                            <TableCell width={250}>{t('name')}</TableCell>
                            <TableCell width={400}>{t('description')}</TableCell>
                            {/* <TableCell>Code</TableCell> */}
                            <TableCell align="right">{t('qty')}</TableCell>
                            <TableCell align="right" width={150}>{t('uom')}</TableCell>
                            <TableCell align="right" width={150}>{t('price')}</TableCell>
                            <TableCell align="right" width={150}>{t('total')} ({currencyAbb})</TableCell>
                            {/* <TableCell align="right">Unit</TableCell> */}
                            {/* <TableCell align="right">Sum</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data?.items.map((row, index) => (
                                <TableRow key={row.id}>
                                    <TableCell>{(index + 1)}</TableCell>
                                    {/* <TableCell align="center">
                                    {
                                        row.is_post_stock === "1"? 'Yes' : '-'
                                    }
                                </TableCell> */}
                                    <TableCell>{row.code}</TableCell>
                                    <TableCell>{row.item_name}</TableCell>
                                    <TableCell>{row.description}</TableCell>
                                    {/* <TableCell>{row.code}</TableCell> */}
                                    <TableCell align="right">{row.qty}</TableCell>
                                    <TableCell align="right">{row.uom_name}</TableCell>
                                    <TableCell align="right">{row.uom_price}</TableCell>
                                    <TableCell align="right">{(row.sub_price)}</TableCell>
                                    {/* <TableCell align="right">{row.unit}</TableCell>
                                <TableCell align="right">{ccyFormat(row.price)}</TableCell> */}
                                </TableRow>
                            ))
                        }
                        {/* <TableRow>
                        <TableCell colSpan={2} align="right">Subtotal</TableCell>
                        <TableCell align="right">{ccyFormat(100)}</TableCell>
                    </TableRow> */}
                        {/* <TableRow>
                        <TableCell>Tax</TableCell>
                        <TableCell align="right">{`${(TAX_RATE * 100).toFixed(0)} %`}</TableCell>
                        <TableCell align="right">{ccyFormat(invoiceTaxes)}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell colSpan={2}>Total</TableCell>
                        <TableCell align="right">{ccyFormat(invoiceTotal)}</TableCell>
                    </TableRow> */}
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const RenderTableFooter = () => {

        if (!data) return <></>

        return (
            <DocumentViewFooter
                data={data}
                showTax={Boolean(true)}
            />
        )
    }

    const RenderFormProfile = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesAttachedToDocument`)}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('placeBy')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document?.profile_name} ({data?.document?.code})
                                </StyledContent>
                                <StyledContent2>
                                    {data?.document?.address_1} {data?.document?.address_2} {data?.document?.postcode}, {data?.document?.area} {data?.document?.country_name}
                                </StyledContent2>
                                <StyledContent2>
                                    {data?.document?.contact} / {data?.document?.email}
                                </StyledContent2>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormPayment = () => {
        return (
            <StyledCard sx={{ mt: 1 }}>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`payment`)}
                            subTitle={t(`relatedPaymentAttachedToDocument`)}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('paymentMethod')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.payment?.payment_type_lbl}
                                </StyledContent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('paymentType')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.payment?.bank_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('payerName')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.payment?.bank_account_name}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('receivedAmount')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {currencyAbb} {formatCurrencyDisplay(parseFloat(data?.payment?.receive_amount))}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('orderAmount')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {currencyAbb} {formatCurrencyDisplay(parseFloat(data?.payment?.payment_amount))}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('documentNo')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_number}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>{t('documentDate')}</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_date}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                    {t('status')}
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.is_active_status === "1" ? 'Active' : 'Cancelled'}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                    {t('stockPosted')}
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.is_post_stock === "1" ? 'Completed' : 'No'}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>
                                    {t('remark')}
                                </StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {data?.document.doc_remark}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDependency = () => {
        return (
            <ViewDocumentDependency
                routeType={routeType}
                data={data?.document}
            />
        )
    }

    const RenderForm = () => {
        return (
            <>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                        {
                            RenderFormProfile()
                        }
                        {
                            RenderFormPayment()
                        }
                        {
                            RenderFormDependency()
                        }
                    </Grid>
                </Grid>

                <Box
                    sx={{
                        textAlign: 'left',
                        mt: 3,
                        pl: 0.5,
                    }}
                >
                    <CommonSectionHeader
                        title={t(`items`)}
                        subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                    />
                </Box>

                <StyledCard
                    sx={{
                        mt: 1.5,
                        p: 0
                    }}
                >
                    <Grid container rowSpacing={0}>
                        <Grid item md={12}>
                            <RenderTable />
                        </Grid>
                        <Grid item md={12}>
                            <RenderTableFooter />
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"center"}>
                        <Button
                            type="button"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            // loading={isLoading}
                            onClick={() => navigate(-1)}
                        >
                            {t('back')}
                        </Button>
                    </Grid>
                </Grid>
            </>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.viewRetailCashSales })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`${t('retailCashSale')} ${data?.document.doc_number}`}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("retailCashSales"),
                        props: {
                            // underline: "hover",
                            href: getRoute("documents/retailCashSales")
                        }
                    },
                    {
                        displayText: `#${data?.document.doc_number}`,
                        props: {
                            // disabled: true,
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    RenderForm()
                    :
                    (
                        <CommonRestricted />
                    )
            }

            {
                DocumentQrCode({
                    data,
                    outputType: scanDataOutputTypes.qrcode,
                    scopeType: scanDataScopeTypes.document,
                    targetType: scanDataTargetTypes.document.retailCashSales
                })
            }

        </Box>
    )
}